import SubLabel from "components/Atoms/Sublabel";
import React from "react";
import { PhosphorIconProps } from "./PhosphorIcon";

interface Props {
  iconComp: (props: PhosphorIconProps) => JSX.Element;
  label: string;
  sublabel?: string;
  variant: "yellow" | "green" | "primary";
}

export const Badge = (props: Props) => {
  const Icon = props.iconComp;

  return <div className={`badge badge-${props.variant}`}>
    <div style={{ marginTop: 2 }}>
      <Icon iconSize="small" iconWeight="bold" iconColor={props.variant} />
    </div>
    <div className="flex-column gap-mini">
      <div>{props.label}</div>
      {props.sublabel && <SubLabel small>{props.sublabel}</SubLabel>}
    </div>
  </div>
}